
  <oe-flat-widget [title]="'GENERAL.SENSORS' | translate" [icon]="{name: 'oe-production', color: 'production'}" class="signage-font-nowrap">
    <ng-container>
        <oe-flat-widget-line
        [name]="'GENERAL.IRRADIANCE' | translate"
        [channelAddress]="'sensor0' + '/TotalIrradiance'"
        [converter]="CONVERT_TO_LUX">
      </oe-flat-widget-line>

      <oe-flat-widget-line
      [name]="'GENERAL.TEMPERATURE'| translate"
      [channelAddress]="'sensor0' + '/AmbientTemperature'"
      [converter]="CONVERT_TO_DEGREES">
    </oe-flat-widget-line>

    <oe-flat-widget-line
    [name]="'GENERAL.TEMPERATURE1'| translate"
    [channelAddress]="'sensor0' + '/PvTemperature'"
    [converter]="CONVERT_TO_DEGREES">
     </oe-flat-widget-line>

    </ng-container>
 </oe-flat-widget>

